import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from './assets/locales/en.json';
import hi from './assets/locales/hi.json';
import bn from './assets/locales/bn.json';
import mr from './assets/locales/mr.json';
import ta from './assets/locales/ta.json';
import te from './assets/locales/te.json';

const resources = {
    en,
    hi,
    bn,
    mr,
    ta,
    te
};

i18n.use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem("selectedLanguage") || 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;